
export default {
  partner: null,
}
